import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Helper function to get status color
const getStatusColor = (status) => {
	const statusColors = {
		'Draft': '#6c757d',
		'Sent': '#007bff',
		'Received': '#17a2b8',
		'Review': '#ffc107',
		'Shortlist': '#28a745',
		'Turndown': '#dc3545',
		'Cancel': '#6c757d',
		'Contracted': '#28a745'
	};
	return statusColors[status] || '#6c757d';
};

// Helper function to count completed sections
const getCompletedSections = (venue) => {
	let completed = 0;
	
	if (venue.eventDetails && venue.eventDetails.eventName) completed++;
	if (venue.roomBlock && venue.roomBlock.dailyGrid && venue.roomBlock.dailyGrid.length > 0) completed++;
	if (venue.meetingSpaces && venue.meetingSpaces.length > 0) completed++;
	if (venue.additionalInfo && (venue.additionalInfo.eventDescription || venue.additionalInfo.requestedAmenities?.length > 0)) completed++;
	if (venue.concessions && venue.concessions.length > 0) completed++;
	if (venue.plannerInfo && venue.plannerInfo.email) completed++;
	if (venue.agencyInfo && (venue.agencyInfo.agencyName || venue.agencyInfo.isCommissionable)) completed++;
	if (venue.rfpStatus && venue.rfpStatus.status !== 'Draft') completed++;
	
	return completed;
};

class SourcedVenueOverview extends Component {
	render() {
		const { venue, orgId } = this.props;

		// Get RFP status
		const rfpStatus = venue.rfpStatus?.status || 'Draft';
		const eventName = venue.eventDetails?.eventName || 'Not set';
		const hasEventDetails = venue.eventDetails && venue.eventDetails.eventName;

		return (
			<div className="sectionContainer" style={{
				marginTop: -20, 
				marginLeft: -30, 
				width: 'calc(100% + 60px)',
				height: 'calc(100% + 20px)'
			}}>
				<div className="sectionBody p-0 noFooter">
					<div className='pageBanner posRel white' style={{ 
						backgroundImage: venue.primaryImage 
							? `linear-gradient(135deg, rgb(0 0 0 / 20%) , rgb(0 0 0 / 20%)), url('${venue.primaryImage}')`
							: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
					}}>
						<h1>{venue.name}</h1>
						{venue.location && <h4 className='mb-20'>{venue.location}</h4>}
						{venue.venueType && <h3>{venue.venueType} Venue</h3>}
						
						{venue.capacity?.max && (
							<p className='mb-20'>
								<i className="las la-users mr-10" />
								Capacity: Up to {venue.capacity.max} guests
							</p>
						)}

					<div className='flex aic wrap mb-20'>
						<Link to={`/${orgId}/venues/${venue._id}/info`}>
							<button className='neu min mr-25 mb-10'>Venue Details</button>
						</Link>
						<Link to={`/${orgId}/venues/${venue._id}/event-details`}>
							<button className='prim min mr-25 mb-10'>{hasEventDetails ? 'Edit' : 'Start'} RFP</button>
						</Link>
						<Link to={`/${orgId}/venues/${venue._id}/rfp-status`}>
							<button className='neu min mr-25 mb-10'>View Status</button>
						</Link>
					</div>
					</div>

					<div className='mt-50 mb-30 text-c'>
						<h1>RFP Progress</h1>
						<p>Complete each section to build your comprehensive RFP</p>
					</div>

					<div className='flex jcc wrap mb-40' style={{ gap: '20px' }}>
						<div className='neuCard p-30 text-c mb-20' style={{ flex: '0 1 300px', display: 'flex', flexDirection: 'column' }}>
							<div className='mb-20'>
								<i className="las la-tasks" style={{ fontSize: '3.5rem', color: getStatusColor(rfpStatus) }} />
							</div>
							<h3 className='mb-10'>Current Status</h3>
							<h2 className="mb-15" style={{ color: getStatusColor(rfpStatus), fontSize: '2rem' }}>{rfpStatus}</h2>
							<p className='grey mb-20' style={{ fontSize: '0.9rem', minHeight: '40px' }}>
								{rfpStatus === 'Draft' && 'Complete the RFP sections'}
								{rfpStatus === 'Sent' && 'Awaiting venue response'}
								{rfpStatus === 'Received' && 'Review the proposal'}
								{rfpStatus === 'Review' && 'Team is reviewing'}
								{rfpStatus === 'Shortlist' && 'On the shortlist'}
								{rfpStatus === 'Contracted' && 'Successfully contracted'}
								{rfpStatus === 'Turndown' && 'Proposal declined'}
								{rfpStatus === 'Cancel' && 'RFP cancelled'}
							</p>
							<Link className='w-100' style={{ marginTop: 'auto' }} to={`/${orgId}/venues/${venue._id}/rfp-status`}>
								<button className='prim w-100'>Update Status</button>
							</Link>
						</div>

						<div className='neuCard p-30 text-c mb-20' style={{ flex: '0 1 300px', display: 'flex', flexDirection: 'column' }}>
							<div className='mb-20'>
								<i className="las la-calendar-alt" style={{ fontSize: '3.5rem', color: '#007bff' }} />
							</div>
							<h3 className='mb-10'>Event</h3>
							<h4 className="mb-15" style={{ fontSize: '1.2rem' }}>{eventName}</h4>
							<p className='grey mb-20' style={{ fontSize: '0.9rem', minHeight: '40px' }}>
								{hasEventDetails ? 'Event details configured' : 'No event details yet'}
							</p>
							<Link className='w-100' style={{ marginTop: 'auto' }} to={`/${orgId}/venues/${venue._id}/event-details`}>
								<button className='neu w-100'>{hasEventDetails ? 'Edit' : 'Add'} Details</button>
							</Link>
						</div>

						<div className='neuCard p-30 text-c mb-20' style={{ flex: '0 1 300px', display: 'flex', flexDirection: 'column' }}>
							<div className='mb-20'>
								<i className="las la-list-check" style={{ fontSize: '3.5rem', color: '#28a745' }} />
							</div>
							<h3 className='mb-10'>Sections Completed</h3>
							<h2 className="mb-15" style={{ fontSize: '2.5rem' }}>{getCompletedSections(venue)}<span style={{ fontSize: '1.5rem', color: '#999' }}>/8</span></h2>
							<p className='grey mb-20' style={{ fontSize: '0.9rem', minHeight: '40px' }}>Fill out all RFP sections</p>
							<Link className='w-100' style={{ marginTop: 'auto' }} to={`/${orgId}/venues/${venue._id}/event-details`}>
								<button className='neu w-100'>Continue RFP</button>
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SourcedVenueOverview;
